import * as React from "react";
import { observer, inject } from "mobx-react";
import SeekerStore from "../../../stores/seekerStore";
import { ScreenMode } from "../../../models/enums";
import { ILocalization, IStartMenu } from "../../../models/localization";
import { Row, Col } from "react-flexbox-grid";
import FeaturedContent from "../../../models/featuredContent";
import { FeatureLevel, EmptyId } from "../../../models/enums";
import * as s from "./secondary.css";

@inject("store") @observer
export class Secondary extends React.Component<{ store: SeekerStore }, {}> {

  constructor(props: any) {
    super(props);
  }

  render(): JSX.Element {
    const tertiaryItems: Array<FeaturedContent> = this.props.store.viewState.featuredContent.filter((fc: FeaturedContent): boolean => { return fc.level === FeatureLevel.Tertiary });
    let img: string = "";
    tertiaryItems.map((fc: FeaturedContent, i: number): void => {
      img = `/image/${fc.imageId}`;
    })
    const mode: ScreenMode = this.props.store.viewState.screenMode;
    const localization: ILocalization = this.props.store.localization.fields;
    const local: IStartMenu = this.props.store.localization.fields.startMenu;
    if (!local.secondaryText) { return null; }
    if (img.length < 1 || img === `/image/${EmptyId}`) { img = "images/image3.jpeg"; }
    return (<Col xs={12} className={s.col}>
      <Row className={s.row}>
        <Col xs={12} sm={6} last="xs" first="sm" className={s.col}>
          <img src={img} />
        </Col>
        <Col xs={12} sm={6}>
          <Row className={s.contentRow}>
            <Col xs={12}>
              <h3 className={s.header}>{local.secondaryHeader}</h3>
            </Col>
            <Col xs={12}>
              {mode === ScreenMode.Desktop && <h6 className={s.content}>{local.secondaryText}</h6>}
              {mode !== ScreenMode.Desktop && <p className={s.content}>{local.secondaryText}</p>}
            </Col>
          </Row>
        </Col>
      </Row>
    </Col>)
  }
}


// WEBPACK FOOTER //
// ./src/components/start/secondary/index.tsx